<style scoped>
.background {
  background-color: #f0f0f0;
}
</style>


<template>
  <v-dialog max-width="800" :value="dialoglogin" persistent>
    <v-card class="br-10 pa-8 text-center" v-if="!forgotpassword">
      <v-card-title row wrap align-end>
        <span class="title primary--text pb-4"><strong>{{ $t('login' )}}</strong></span>
        <v-spacer></v-spacer>
        <v-btn text large @click="setPageLoading({ loading: false }); setLoginVisible({ visible: false })" class="primary--text" icon style="margin-top: -20px; margin-right: -10px">
          <v-icon style="font-size: 25px;">fa-close fa-lg</v-icon>
        </v-btn>
      </v-card-title>
      <v-layout class="pa-3" column wrap >
        <v-form @submit.prevent="submitForm($event)">
          <v-text-field prepend-icon="fa-envelope fa-lg" :error-messages="errors.collect('email_address')" :value="data.name" @input="patchData({ name: $event })" autofocus :label="$t('email_address')" name="email_address" required type="text" v-validate="rules.email_address"></v-text-field>
          <v-text-field :error-messages="errors.collect('password')" :value="data.password" @input="patchData({ password: $event })" :label="$t('password')" name="password" required type="password" prepend-icon="fa-lock fa-lg" v-validate="rules.password"></v-text-field>
          <v-layout align-center justify-center class="pt-3" v-if="authError">
            <span class="error--text subheading"><strong>{{ $t('auth_error') }}</strong></span>
          </v-layout>
          <span class="pt-2" row>
            {{ $t('not_a_member') }}?
            <v-btn color="blue darken-2" small text rounded router outlined class="pr-4 pl-4" @click="$router.push('/user/form'); setLoginVisible({ visible: false })">{{ $t('register' )}}</v-btn>
          </span>
          <v-layout align-center justify-end :reverse="$vuetify.breakpoint.xsOnly" :column="$vuetify.breakpoint.xsOnly" class="pt-3">
            <v-btn :block="$vuetify.breakpoint.xsOnly" @click="setForgotPasswordVisible({ visible: true })" color="primary" text rounded>{{ $t('forgot_password') }}?</v-btn>
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" large rounded type="submit">{{ $t('login' )}}</v-btn>
          </v-layout>
        </v-form>
      </v-layout>
      <v-divider v-if="homepage"></v-divider>
      <v-layout class="pa-3 background" row wrap  v-if="homepage">
        <v-layout align-center justify-center :reverse="$vuetify.breakpoint.xsOnly" :column="$vuetify.breakpoint.xsOnly" class="pt-3">
          <v-btn :block="$vuetify.breakpoint.xsOnly" color="blue" large rounded @click="setLoginVisible({ visible: false })" router :to="{ path: '/checkout' }" class="guestBtn">{{ $t('continue_guest' )}}</v-btn>
        </v-layout>
      </v-layout>
    </v-card>
    <v-card class="br-10 pa-3 text-center" v-if="forgotpassword">
      <v-card-title row wrap align-end>
        <span class="title primary--text pb-4"><strong>{{ $t('dialog_forgotPassword', { 'council': '' } )}}</strong></span>
        <v-spacer></v-spacer>
        <v-btn text large @click="setPageLoading({ loading: false }); setLoginVisible({ visible: false })" class="primary--text" icon style="margin-top: -20px; margin-right: -10px">
          <v-icon style="font-size: 25px;">fa-close fa-lg</v-icon>
        </v-btn>
      </v-card-title>
      <v-layout class="pa-3" column wrap >
        <v-form @submit.prevent="submitForm($event)">
          <v-text-field prepend-icon="fa-envelope fa-lg" :error-messages="errors.collect('email_address')" :value="dialog.email" @input="setDialogEmail({ email: $event })" autofocus :label="$t('email_address')" name="email_address" required type="email" v-validate="rules.email_address"></v-text-field>
          <v-layout align-center justify-center>
            <span class="body-2 blue--text pb-4"><strong>{{ $t('message_email_reset_password' )}}</strong></span>
          </v-layout>
          <v-layout align-center justify-end :reverse="$vuetify.breakpoint.xsOnly" :column="$vuetify.breakpoint.xsOnly" class="pt-3">
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" large rounded @click="submitRequest()">{{ $t('submit') }}</v-btn>
          </v-layout>
        </v-form>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '../i18n'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      authError: (state) => state.auth.error,
      dialog: (state) => state.login.dialog,
      dialoglogin: (state) => state.dialog.dialoglogin,
      data: (state) => state.login.data,
      homepage: (state) => state.dialog.homepage,
      rules: (state) => state.login.rules,
      forgotpassword: (state) => state.dialog.forgotpassword
    }),
    isValid: function () {
      return Object.keys(this.fields).every((key) => this.fields[key].valid)
    }
  },
  methods: {
    ...mapActions({
      authLogIn: 'auth/logIn',
      patchData: 'login/patchData',
      resetData: 'login/resetData',
      resetPassword: 'login/resetPassword'
    }),
    ...mapMutations({
      setDialogEmail: 'login/setDialogEmail',
      setForgotPasswordVisible: 'dialog/setForgotPasswordVisible',
      setLoginVisible: 'dialog/setLoginVisible',
      setPageLoading: 'loading/setPageLoading'
    }),
    submitRequest: async function ($event) {
      await this.resetPassword()
      this.$store.dispatch('snackbar/setSnackBar', {color: 'success', message: i18n.t('email_sent'), visible: true})
      this.resetData()
      this.setForgotPasswordVisible({ visible: false })
      this.setLoginVisible({ visible: false })
    },
    submitForm: async function ($event) {
      const response = await this.authLogIn(this.data)
      if (!response.error) {
        this.resetData()
        // this.$router.replace({ path: '/' })
        this.setLoginVisible({ visible: false })
        if (this.homepage) {
          this.$router.replace({ path: '/checkout' })
        }
      } else {
        this.$router.replace({ path: '/' })
        this.setLoginVisible({ visible: true })
      }
    }
  },
  props: {
    title: {
      default: 'e-Perkhidmatan',
      type: String
    }
  }
}
</script>
